import React from 'react';
import { Users } from 'lucide-react';
export function InstructorsHero() {
  return <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-411">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-412">
        <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-413">
          <Users className="h-6 w-6 text-[#dc2626]" data-id="element-414" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-415">Instructor Team</h1>

        <p className="text-lg text-slate-200 max-w-2xl mx-auto" data-id="element-416">
          Meet the Che Ko instructor team. Our coaches support students across
          all locations and programs.
        </p>
      </div>
    </section>;
}